import type { ParsedComposeMessage } from '../useData';
import { importMessageToEditableEditorHtml } from '../utils/unlockReplyForwardEditing';
import type { ComposeBodyDocument } from './types';

export function importToComposeDoc(parsed: ParsedComposeMessage): ComposeBodyDocument {
  const userBody = importMessageToEditableEditorHtml(parsed.html, parsed.text);

  return {
    bodyKind: 'rich',
    userBody: userBody.trim() || '<div><br></div>',
  };
}
